/**
 * Helpers recrutement (A-24) — agrégation KPI depuis le registre candidatures.
 */
import type { Candidature, StatutCandidature } from '@shared/types/Recrutement';
import { RecrutementService } from '@domain/rh/RecrutementService';

export type OffreRecrutement = {
  id: string;
  poste: string;
  service: string;
  type: string;
  date: string;
  statut: string;
};

export function compterCandidats(candidatures: readonly Candidature[], offreId?: string): number {
  if (!offreId) return candidatures.length;
  return candidatures.filter((c) => c.poste_id === offreId).length;
}

export function kpisRecrutement(
  offres: readonly OffreRecrutement[],
  candidatures: readonly Candidature[],
  moisCourant: string = new Date().toISOString().slice(0, 7),
): { ouvertes: number; candidats: number; entretiens: number; embauchesMois: number } {
  const ouvertes = offres.filter((o) => o.statut === 'ouverte').length;
  const candidats = candidatures.length;
  const entretiens = candidatures.filter((c) => c.statut === 'entretien').length;
  const embauchesMois = candidatures.filter(
    (c) => c.statut === 'acceptee' && c.date_reception.slice(0, 7) === moisCourant,
  ).length;
  return { ouvertes, candidats, entretiens, embauchesMois };
}

export function pipelineOffre(
  candidatures: readonly Candidature[],
  offreId: string,
): Record<StatutCandidature, number> {
  return RecrutementService.pipelinePoste(candidatures, offreId);
}
